@import 'apps/webcomponents/src/assets/fonts.scss';

* {
  box-sizing: border-box;
}

:host {
  --table-border-color: var(--chart-100-pressed);
  --table-text-color: var(--main-titles-inputs-600);
  --table-cell-color-default: transparent;
  --table-cell-color-hovered: var(--chart-100-pressed);
  --table-cell-color-selected: var(--red-alert-500-severe);
  --form-field-label-width: 250px;
}

table {
  border-collapse: collapse;
  font-family: var(--font-family-secondary);
  font-weight: 400;
  font-size: var(--body-size-medium);
  border-spacing: 1px;
}

th,
td {
  width: calc(10 * var(--spacer));
  height: calc(4 * var(--spacer));
  border: 1px solid var(--table-border-color);
  color: var(--table-text-color);
  text-align: center;
  font-weight: 400;
}

thead {
  th {
    border-top: none;
    border-left: none;
    border-right: none;
  }
}

.day-selector,
.hour-selector {
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: var(--table-cell-color-hovered);
  }
}

/* Hidden checkbox */
.time-slot {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.time-slot:hover + label {
  background-color: var(--table-cell-color-hovered);
}

/* Selected state via checkbox */
.time-slot.selected + label {
  background-color: var(--table-cell-color-selected);
}

.table-cell-label {
  display: block;
  height: calc(100% + 2px);
  width: calc(100% + 2px);
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: var(--table-cell-color-default);
}

.radio-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  &:first-of-type {
    margin-bottom: var(--spacer);
  }
}

.radio-group {
  display: inline-flex;
  flex-direction: column;
  margin-bottom: calc(3 * var(--spacer));
}

.swatch {
  width: calc(4 * var(--spacer));
  height: var(--spacer);
  border: 1px solid var(--table-border-color);
  margin-bottom: var(--spacer);
  margin-left: calc(2 * var(--spacer));
  &.block {
    background-color: var(--table-cell-color-selected);
  }
  &.default {
    background-color: var(--table-cell-color-default);
  }
}

.form-label {
  width: var(--form-field-label-width);
  font-size: var(--body-size);
  font-family: var(--font-family);
  padding-top: var(--spacer);
  color: var(--main-titles-inputs-600);
  display: inline-table;
  &::after {
    content: ':';
  }
}

gz-info-box {
  transform: translateX(calc(-1 * var(--spacer)));
  margin-bottom: calc(3 * var(--spacer));
}
